import Head from "next/head";
import React from "react";
import {getTransString} from "src/components/_common/Carbon";

import {QA} from "./Faq";

type Props = {
  faq: QA[];
};

const SchemaHead: React.FC<Props> = ({faq}) => (
  <Head>
    <script
      key="schema-faq"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faq.map(qa => ({
            "@type": "Question",
            name: qa.q,
            acceptedAnswer: {
              "@type": "Answer",
              text: getTransString(qa.a),
            },
          })),
        }),
      }}
    />
  </Head>
);

export default SchemaHead;
